<template>
  <div>
    <div class="px-3">
      <FilterWrapper>
        <template slot="filterForm">
          <MerchantWalletFilter
            :loading="loading"
            :rLoading="rLoading"
            :submitFilter="refetch"
            :clearFilter="() => clearFilter('walletsRef')"
          />
        </template>
      </FilterWrapper>
    </div>
    <TableWrapper
      :loading="loading"
      :errorMsg="errorMsg"
      :refetch="fetchWallets"
      :isEmpty="isEmpty"
      :emptyTitle="emptyTitle"
    >
      <div class="w-100 py-3" slot="content">
        <v-server-table
          ref="walletsRef"
          class="v-table row-pointer"
          :data="customers"
          :columns="columns"
          :options="options"
          @loading="setLoading(true)"
          @loaded="onLoaded"
          @row-click="handleClick"
        >
          <template slot="account_name" slot-scope="{ row }">
            {{ row.account_name || 'N/A' }}
          </template>
          <template slot="account_number" slot-scope="{ row }">
            {{ row.account_number || 'N/A' }}
          </template>
          <template slot="bank_name" slot-scope="{ row }">
            {{ row.bank_name || 'N/A' }}
          </template>
          <template slot="createdAt" slot-scope="{ row }">
            {{ row.createdAt | moment(" MM-DD-YYYY h:mm a") }}
          </template>
        </v-server-table>
      </div>
    </TableWrapper>
  </div>
</template>

<script>
import { componentData } from "../../../../../public/assets/mixins/componentData";
import TableWrapper from "../../../../components/utils/TableWrapper/TableWrapper.vue";
import MerchantWalletFilter from "../../../../components/filters/MerchantWalletFilter";

const tableHeadings = {
  account_name: "Account Name",
  account_number: "Account Number",
  bank_name: "Bank Name",
  wallet_id: "Wallet Id",
  reference: "Reference",
  createdAt: "Date Created",
};

export default {
  name: "Wallet",
  mixins: [componentData],
  data() {
    return {
      singleInviteObj: null,
      showSingleInviteModal: false,
      emptyTitle: "No Wallet Found",
      showInviteModal: false,
      loading: false,
      errorMsg: "",
      customers: [],
      ...this.tableOptions(tableHeadings, 25),
    };
  },
  components: {
    TableWrapper,
    MerchantWalletFilter,
  },
  methods: {
    handleClick({ row }) {
      this.$router.push(
        `/single-wallet/${this.clientid}/${row.id}/${row.reference}`
      );
    },
    refetch(filters) {
      let newFilters = { ...filters };
      if (newFilters.status) newFilters.status = newFilters.status.value;
      this.handleRefetch(newFilters, this.fetchWallets, "walletsRef");
    },
    async fetchWallets() {
      this.options.requestFunction = async (data) => {
        const params = { ...data, ...this.filters, ref: this.clientid };
        const response = await this.$store.dispatch(
          "customer/getPaymentMerchantWallets",
          {
            params,
          }
        );

        const newData = response.data.data;
        const count = response.data.total;
        return { ...response, count, total: count, data: newData };
      };
    },
  },

  props: ["clientid"],
  created() {
    this.fetchWallets();
  },
  mounted() {
    this.columns = Object.keys(tableHeadings).map((keyVal) => keyVal);
  },
};
</script>
